import React from 'react';

import { func_validation, func_cookieSetting, func_datetime } from 'functions';

export const tableColumns = {
    // Columns Array
    getColumns,

    // Columns
    getColumns_invoiceID,
    getColumns_SqlAccountInvoiceNo,
    getColumns_creditNoteRefDocNo,
    getColumns_accountCode,
    getColumns_date,
    getColumns_amount,
    getColumns_lastSentEmail,
    getColumns_documentDate,
}

function getColumns() {
    return [
        getColumns_invoiceID(),
        getColumns_SqlAccountInvoiceNo(),
        getColumns_creditNoteRefDocNo(),
        getColumns_accountCode(),
        getColumns_date(),
        getColumns_documentDate(),
        getColumns_lastSentEmail(),
        getColumns_amount(),
    ];
}

function getColumns_accountCode() {
    let columnClassName = "advancePayInvoices-tableColumn-accountCode";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Account Code",
        id: "accountCode",
        accessor: "AccountCode",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_invoiceID() {
    let columnClassName = "advancePayInvoices-tableColumn-invoiceID";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Invoice ID",
        id: "invoiceID",
        accessor: "Id",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isNumberValid(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_SqlAccountInvoiceNo() {
    let columnClassName = "advancePayInvoices-tableColumn-sqlAccountInvoiceNo";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Reference Document No.",
        id: "sqlAccountInvoiceNo",
        accessor: "ReferenceDocumentNo",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
        width: 300
    }
}

function getColumns_creditNoteRefDocNo() {
    let columnClassName = "advancePayInvoices-tableColumn-creditNoteRefDocNo";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Credit Note Reference Document No.",
        id: "creditNoteRefDocNo",
        accessor: "CreditNoteRefDocNo",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
        width: 300
    }
}

function getColumns_date() {
    let columnClassName = "advancePayInvoices-tableColumn-issueDate";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Issue Date",
        // isHeaderColumnSortable: true,
        // sortValue: "issueDate"
        id: "issueDate",
        accessor: "IssueDateTime",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
            if (func_validation.isStringTrimNotEmpty(value_formatted) && (value_formatted != "-")) 
                value_formatted = func_datetime.convertDateTimeToLocal(value_formatted, "DD/MM/YYYY");

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_amount() {
    let columnClassName = "advancePayInvoices-tableColumn-subtotal";

    return {
        headerCellClassName: columnClassName + " justify-content-start",
        Header: "SubTotal (RM)",
        // isHeaderColumnSortable: true,
        // sortValue: "subTotal"
        id: "subTotal",
        accessor: "SubTotal",
        bodyCellClassName: columnClassName + " justify-content-end",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isNumberValid(value)? value: "-";
            if (value_formatted != "-")
                value_formatted = func_cookieSetting.getFormattedPrice(value_formatted, { currencyDisabled: true });

            return (
                <div className={"noWrap-text-ellipsis "}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_lastSentEmail() {
    let columnClassName = "advancePayInvoices-tableColumn-lastSentEmail";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Last Sent Email",
        // isHeaderColumnSortable: true,
        // sortValue: "lastSentEmail"
        id: "lastSentEmail",
        accessor: "LastSendEmail",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
            if (func_validation.isStringTrimNotEmpty(value_formatted) && (value_formatted != "-")) 
                value_formatted = func_datetime.convertDateTimeToLocal(value_formatted, "DD/MM/YYYY");

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_documentDate() {
    let columnClassName = "advancePayInvoices-tableColumn-documentDate";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Document Date",
        // isHeaderColumnSortable: true,
        // sortValue: "documentDate"
        id: "documentDate",
        accessor: "DocumentDateTime",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
            if (func_validation.isStringTrimNotEmpty(value_formatted) && (value_formatted != "-")) 
                value_formatted = func_datetime.convertDateTimeToLocal(value_formatted, "DD/MM/YYYY");

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}